import { Theme } from '@mui/material'
import {
  loadStripe,
  StripeElementsOptions,
  StripeElementsOptionsMode,
  StripeExpressCheckoutElementOptions,
  StripePaymentElementOptions
} from '@stripe/stripe-js'
import { env } from 'config'

export const stripePromise = loadStripe(env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '')

export const elementsOptions = (theme: Theme): StripeElementsOptionsMode => ({
  mode: 'setup',
  currency: 'usd',
  loader: 'never',
  payment_method_types: ['card'],
  appearance: {
    variables: {
      colorPrimary: theme.palette.members.primary,
      focusBoxShadow: `0px 0px 0px 3px ${theme.palette.members.shadow}`
    },
    rules: {
      '.Label': {
        fontSize: '0'
      },
      '.Input': {
        boxShadow: 'none'
      }
    }
  }
})

export const paymentElementOptions: StripePaymentElementOptions = {
  fields: {
    billingDetails: {
      address: {
        country: 'never',
        postalCode: 'never'
      }
    }
  },
  terms: {
    card: 'never'
  },
  wallets: {
    applePay: 'never',
    googlePay: 'never'
  }
}

export const expressCheckoutElementsOptions: StripeElementsOptions = {
  mode: 'setup',
  currency: 'usd',
  setupFutureUsage: 'off_session',
  paymentMethodTypes: ['card']
}

export const expressCheckoutOptions: StripeExpressCheckoutElementOptions = {
  buttonTheme: {
    applePay: 'black'
  },
  buttonType: {
    applePay: 'subscribe'
  },
  buttonHeight: 46,
  shippingAddressRequired: true,
  allowedShippingCountries: ['US'],
  paymentMethods: {
    applePay: 'always',
    googlePay: 'never',
    link: 'never',
    paypal: 'never'
  },
  layout: {
    overflow: 'never'
  }
}
